// Reusable ShimmerBar component
const ShimmerBar = ({ className }: { className?: string }) => (
  <div className={`bg-muted dark:bg-muted-foreground/20 animate-pulse rounded ${className}`} />
);

function AccountCardSkeleton() {
  return (
    <div className="inline-flex align-top flex-shrink-0">
      <div className="min-w-[15rem] h-[10rem] relative">
        <div className="bg-card h-full overflow-hidden border-[0.7px] border-border rounded-2xl">
          <div className="p-4 bg-secondary h-full flex flex-col justify-between">
            {/* Top row: Icon + Balance */}
            <div className="flex items-center justify-between">
              <div className="w-6 h-6 rounded bg-muted dark:bg-muted-foreground/20 animate-pulse" />
              <ShimmerBar className="w-20 h-7" />
            </div>

            {/* Middle row: Name + Type badge */}
            <div className="flex items-center justify-between gap-2 min-w-0">
              <ShimmerBar className="w-2/3 h-7" />
              <ShimmerBar className="w-14 h-6 rounded-full" />
            </div>

            {/* Bottom row: Account number */}
            <div className="flex flex-col items-start gap-1">
              <ShimmerBar className="w-24 h-4" />
              <div className="flex items-center gap-2">
                <ShimmerBar className="w-24 h-5" />
                <div className="w-4 h-4 rounded bg-muted dark:bg-muted-foreground/20 animate-pulse" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountCardSkeleton; 
